import { useNavigate } from "react-router-dom";
import { MonoButton } from "../kits";

const GOLD = "#AC8E66";

const PILLARS = [
  { id: "01", label: "Software Architektur", desc: "Skalierbare Systeme, die Bestand haben" },
  { id: "02", label: "Full-Stack Entwicklung", desc: "React · Angular · Flutter · three.js" },
  { id: "03", label: "Technical Education", desc: "Wissen, das im Alltag wirkt" },
];

export default function HeroStatementSection({ className = "", isDark = false }) {
  const navigate = useNavigate();
  const BG     = isDark ? "#151515" : "#d0cbb8";
  const TEXT   = isDark ? "#e8e0d4" : "#1a1a1a";
  const MUTED  = isDark ? "#b0ac9b" : "#2a2a2a";
  const BORDER = isDark ? "#2a2a2a" : "#b5b0a0";
  const ACCENT = isDark ? "#AC8E66" : "#1a1a1a";
  const buttonClasses = isDark
    ? "px-6 py-2 text-sm border-brand bg-[#151515] hover:bg-[#1c1c1c]"
    : "px-6 py-2 text-sm border-[#1a1a1a]/25 bg-[#b8b2a0] hover:bg-[#b0aa98]";
  const buttonText = isDark ? "text-brand" : "text-[#1a1a1a]";

  return (
    <section
      style={{
        background: BG,
        borderBottom: `1px solid ${BORDER}`,
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      }}
      className={className}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "88px 32px 80px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "80px",
          alignItems: "center",
        }}
        className="hero-statement-grid"
      >
        {/* Links: Headline + CTA */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "36px",
            }}
          >
            <span
              style={{
                border: `1px solid ${ACCENT}`,
                color: ACCENT,
                fontSize: "0.6rem",
                padding: "2px 8px",
                letterSpacing: "0.14em",
                textTransform: "uppercase",
              }}
            >
              Software Architect
            </span>
            <span
              style={{
                border: `1px solid ${BORDER}`,
                color: MUTED,
                fontSize: "0.6rem",
                padding: "2px 8px",
                letterSpacing: "0.14em",
                textTransform: "uppercase",
              }}
            >
              Hamburg
            </span>
          </div>

          <h1
            style={{
              color: TEXT,
              fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)",
              fontWeight: 700,
              lineHeight: 1.2,
              margin: "0 0 24px 0",
            }}
          >
            Probleme lösen.{" "}
            <span style={{ color: GOLD }}>Systeme bauen.</span>{" "}
            Wissen teilen.
          </h1>

          <p
            style={{
              color: MUTED,
              fontSize: "0.88rem",
              lineHeight: 1.8,
              margin: "0 0 48px 0",
            }}
          >
            Keine Software um ihrer selbst willen.
            Sondern Systeme, die funktionieren —
            und verstanden werden.
          </p>

          <MonoButton
            onClick={() => navigate("/about#meinweg")}
            className={buttonClasses}
            textColor={buttonText}
            underlineColors="ZenBrand"
          >
            Mein Weg · Mein Fokus
          </MonoButton>
        </div>

        {/* Rechts: Drei Säulen */}
        <div>
          {PILLARS.map((p) => (
            <div
              key={p.id}
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: "20px",
                padding: "20px 0",
                borderBottom: `1px solid ${BORDER}`,
              }}
            >
              <span
                style={{
                  color: GOLD,
                  fontSize: "0.6rem",
                  letterSpacing: "0.15em",
                  minWidth: "24px",
                  flexShrink: 0,
                }}
              >
                {p.id}
              </span>
              <div>
                <div
                  style={{
                    color: TEXT,
                    fontSize: "0.88rem",
                    fontWeight: 600,
                    marginBottom: "4px",
                  }}
                >
                  {p.label}
                </div>
                <div style={{ color: MUTED, fontSize: "0.75rem" }}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .hero-statement-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
            padding-top: 64px !important;
            padding-bottom: 64px !important;
          }
        }
      `}</style>
    </section>
  );
}
